export default "__VITE_PUBLIC_ASSET__561f3c8c__"